import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  // Theme colors
  const colors = {
    dark: {
      bg: 'bg-[#0a0f1a]',
      bgSecondary: 'bg-[#0f172a]',
      text: 'text-white',
      textSecondary: 'text-gray-400',
      textMuted: 'text-gray-500',
      border: 'border-white/5',
      borderHover: 'border-white/10',
      card: 'bg-white/5',
      cardHover: 'hover:bg-white/10',
      input: 'bg-white/5 border-white/10',
      gridColor: 'rgba(59, 130, 246, 0.08)',
      glowColor: 'bg-blue-500/5'
    },
    light: {
      bg: 'bg-gray-50',
      bgSecondary: 'bg-white',
      text: 'text-gray-900',
      textSecondary: 'text-gray-600',
      textMuted: 'text-gray-500',
      border: 'border-gray-200',
      borderHover: 'border-gray-300',
      card: 'bg-white',
      cardHover: 'hover:bg-gray-50',
      input: 'bg-white border-gray-300',
      gridColor: 'rgba(59, 130, 246, 0.12)',
      glowColor: 'bg-blue-500/10'
    }
  };

  return (
    <ThemeContext.Provider value={{
      theme,
      toggleTheme,
      isDark,
      colors: colors[theme]
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
